import { Loader } from '@nordlayer/rivendell-ui';
import loadable from '@nordvpn/teams.core/lib/tools/loadable';
import { RouteGenerator } from 'routing/RouteGenerator';
import { MEMBERS_LIST_PATH } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
var MembersList = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/MembersList');
});
var MembersListOld = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/MembersListOld');
});
export var MembersRouting = function MembersRouting(_ref) {
    var areFeaturesLoaded = _ref.areFeaturesLoaded, isMembersRedesignEnabled = _ref.isMembersRedesignEnabled;
    var getListPage = function getListPage() {
        if (!areFeaturesLoaded) {
            return /*#__PURE__*/ _jsx(Loader, {
                centered: true
            });
        }
        return isMembersRedesignEnabled ? /*#__PURE__*/ _jsx(MembersList, {}) : /*#__PURE__*/ _jsx(MembersListOld, {});
    };
    return RouteGenerator({
        list: {
            path: MEMBERS_LIST_PATH,
            component: function component() {
                return getListPage();
            },
            exact: true
        }
    });
};
